import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { CalendarComponent, CalendarEvent } from 'src/app/shared';
import { StatusEvent } from 'src/app/shared/models/StatusEvent';
import { ClaimKey } from 'src/app/shared/models/claim-key';
import { ClaimService } from '../../services/claim.service';
import { TitleCasePipe } from '@angular/common';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';
import { TranslationPipe } from '../../pipes/translation.pipe';
import { TranslationService } from '../../services/translation.service';
import { Session } from '../../services/session.service';

@Component({
    selector: 'app-off-work-calendar',
    changeDetection: ChangeDetectionStrategy.Default,
    template: `
    <app-section class="tw-w-full" [IsSmallBox]="false">
      <ng-template #dialogOffWorkExport>
        <app-dialog
          title="Export"
          ariaLabel="Export dialog"
          [width]="700"
          [showActions]="false"
          [showHeader]="false"
          ariaLabelMessage="Close export popup"
          >
          <app-off-work-export
            [offworkdata]="offWorkCalendarEntries"
            [offworkEventData]="calendarevents"
            [translationRequest]="translationRequest"
          ></app-off-work-export>
        </app-dialog>
      </ng-template>
      <app-panel
        title="Claims calendar"
        [headerLevel]="2"
        class="tw-w-full"
        [expanded]="EventCount > 0 || true"
        titleCollapse="Collapse Claims Calendar"
        titleExpand="Expand Claims Calendar"
        >
        <app-loading-panel
          [state]="loading ? 'Loading' : 'Loaded'"
          [loadingHeight]="500"
          loadingStyle="Box"
          [error]="error"
          >
          <ng-template #content>
            <div [hidden]="loading" class="tw-w-full">
              <div class="app-pt2"></div>
              <app-calendar
                [events]="events"
                [IsAbsence]="false"
                [ShowClaimNoLink]="showClaimNoLink"
                (calendarDateUpdated)="dateUpdated($event)"
                toolbarRight="dayGridMonth,dayGridWeek"
                [translationRequest]="translationRequest"
                >
              </app-calendar>
              <div
                class="tw-flex tw-flex-wrap tw-items-center tw-justify-between app-mt2"
                >
                <div
                  class="tw-w-full md:tw-w-[85%] tw-flex tw-flex-wrap tw-items-center"
                  >
                  <div
                    class="tw-w-full sm:tw-w-1/2 tw-flex tw-items-center tw-justify-center sm:tw-justify-start tw-mb-2 sm:tw-pl-8"
                    >
                    <div
                      class="dot tw-bg-[var(--sed-status-green-color)]"
                    ></div>
                    <div class="app-pr2 app-pl1 tw-font-bold">{{'Approved' | translation : translationRequest}}</div>
                  </div>
                  @if (!IsAccomodation) {
                    <div
                      class="tw-w-full sm:tw-w-1/2 tw-flex tw-items-center tw-justify-center sm:tw-justify-start tw-mb-2 sm:tw-pl-8"
                      >
                      <div class="dot tw-bg-[var(--sed-status-blue-color)]"></div>
                      <div class="app-pr2 app-pl1 tw-font-bold">{{'Pending' | translation : translationRequest}}</div>
                    </div>
                  }
                  @if (!IsAccomodation) {
                    <div
                      class="tw-w-full sm:tw-w-1/2 tw-flex tw-items-center tw-justify-center sm:tw-justify-start tw-mb-2 sm:tw-pl-8"
                      >
                      <div class="dot tw-bg-[var(--sed-black-80-color)]"></div>
                      <div class="app-pr2 app-pl1 tw-font-bold">
                        {{'Waiting Period' | translation : translationRequest}}
                      </div>
                    </div>
                  }
                  @if (!IsAccomodation) {
                    <div
                      class="tw-w-full sm:tw-w-1/2 tw-flex tw-items-center tw-justify-center sm:tw-justify-start tw-mb-2 sm:tw-pl-8"
                      >
                      <div class="dot tw-bg-[var(--sed-status-red-color)]"></div>
                      <div class="app-pr2 app-pl1 tw-font-bold">{{'Denied' | translation : translationRequest}}</div>
                    </div>
                  }
                  @if (!IsAccomodation) {
                    <div
                      class="tw-w-full sm:tw-w-1/2 tw-flex tw-items-center tw-justify-center sm:tw-justify-start tw-mb-2 sm:tw-pl-8"
                      >
                      <div class="dot tw-bg-[var(--sed-data-teal-color)]"></div>
                      <div class="app-pr2 app-pl1 tw-font-bold">{{'Event' | translation : translationRequest}}</div>
                    </div>
                  }                  
                  @if (IsAccomodation) {
                    <div class="tw-w-[60%]"></div>
                  }
                </div>
                <div
                  class="tw-w-full md:tw-w-[15%] tw-flex tw-justify-end tw-mt-2 md:tw-mt-0"
                  >
                  <button
                    mat-icon-button
                    aria-label="Export Calendar entries"
                    (click)="export()"
                    >
                    <mat-icon
                      style="color: var(--sed-black-80-color) !important;"
                      >file_download</mat-icon
                      >
                    </button>
                  </div>
                </div>
    
                <ng-template #row let-element>
                  <div class="tw-flex tw-flex-wrap tw-w-full">
                    <app-value
                      label="Name"
                      layout="row-xs"
                      class="tw-w-full md:tw-w-[10%] txt-wrp"
                      [translationNeeded]="false"
                      [valueTemplate]="nameTpl"
                      >
                      <ng-template #nameTpl>
                        <span>{{ element.data.entry.name }}</span>
                      </ng-template>
                    </app-value>
                    <app-value
                      label="Claim Number"
                      layout="row-xs"
                      class="tw-w-full md:tw-w-[10%] txt-wrp"
                      [translationNeeded]="false"
                      [valueTemplate]="claimNumberTpl"
                      >
                      <ng-template #claimNumberTpl>
                        <span>{{ element.data.entry.claimNumber }}</span>
                      </ng-template>
                    </app-value>
                    <app-value
                      label="Type"
                      layout="row-xs"
                      class="tw-w-full md:tw-w-[10%] txt-wrp"
                      [valueTemplate]="typeTpl"
                      >
                      <ng-template #typeTpl>
                        <span>{{ element.data.entry.leaveType }}</span>
                      </ng-template>
                    </app-value>
    
                    <app-value
                      label="First day of absence"
                      layout="row-xs"
                      class="tw-w-full md:tw-w-[10%] txt-wrp"
                      [translationNeeded]="false"
                      [valueTemplate]="firstDayTpl"
                      >
                      <ng-template #firstDayTpl>
                        <span>{{ element.start | format:'date'}}</span>
                      </ng-template>
                    </app-value>
                    <app-value
                      label="Last day of absence"
                      layout="row-xs"
                      class="tw-w-full md:tw-w-[10%] txt-wrp"
                      [translationNeeded]="false"
                      [valueTemplate]="lastDayTpl"
                      >
                      <ng-template #lastDayTpl>
                        @if (
                          !(
                          element.data.entry.isEndDateEmpty !== undefined &&
                          element.data.entry.isEndDateEmpty === true
                          )
                          ) {
                          <span
                            >{{ element.end |format:'date' }}</span
                            >
                          }
                        </ng-template>
                      </app-value>
                      <app-value
                        label="Status"
                        layout="row-xs"
                        class="tw-w-full md:tw-w-[10%] txt-wrp"
                        [valueTemplate]="statusTpl"
                        >
                        <ng-template #statusTpl>
                          <span>
                            {{ element.data.entry.status }}
                          </span>
                        </ng-template>
                      </app-value>
                      <app-value
                        label="Sub status"
                        layout="row-xs"
                        class="tw-w-full md:tw-w-[10%] txt-wrp"
                        [valueTemplate]="subStatusTpl"
                        >
                        <ng-template #subStatusTpl>
                          <span>
                            {{ element.data.entry.subStatus }}
                          </span>
                        </ng-template>
                      </app-value>
                      <app-value
                        label="Hours Absence"
                        layout="row-xs"
                        class="tw-w-full md:tw-w-[10%] flex-right txt-wrp"
                        [valueTemplate]="hoursTpl"
                        >
                        <ng-template #hoursTpl>
                          <span>
                            {{ element.data.entry.hoursMissed }}
                          </span>
                        </ng-template>
                      </app-value>
                      <app-value
                        label="Minutes missed"
                        layout="row-xs"
                        class="tw-w-full md:tw-w-[10%] flex-right txt-wrp"
                        [valueTemplate]="minutesTpl"
                        >
                        <ng-template #minutesTpl>
                          <span>{{ element.data.entry.minutesMissed }}</span>
                        </ng-template>
                      </app-value>
                      @if (element.data.claimDetails.lob !== 'DS') {
                        <app-value
                          label="Reason of absence"
                          layout="row-xs"
                          class="tw-w-full md:tw-w-[10%] txt-wrp"
                          [valueTemplate]="reasonTpl"
                          >
                          <ng-template #reasonTpl>
                            <span>{{ element.data.entry.absenceReason }}</span>
                          </ng-template>
                        </app-value>
                      }
                    </div>
                  </ng-template>
                </div>
              </ng-template>
            </app-loading-panel>
          </app-panel>
        </app-section>
    `,
    styles: [
        `
      .dot {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        display: inline-block;
      }

      @media (max-width: 480px) {
        .dot {
          width: 15px;
          height: 15px;
          border-radius: 50%;
          display: inline-block;
        }
      }

      .txt-small {
        font-size: 12px !important;
      }

      .txt-wrp {
        overflow-wrap: anywhere;
      }
    `,
    ],
    standalone: false
})
export class OffWorkCalendarComponent implements OnInit {
  events: any[] = [];
  @ViewChild('dialogOffWorkExport') dialogOffWorkExport: TemplateRef<any>;
  @ViewChild(CalendarComponent) appCalendar: CalendarComponent;

  loading = true;
  offWorkCalendarEntries: StatusEvent[] = [];
  EventCount: number = 1;

  @Input()
  claimId: string;

  @Input()
  IsAccomodation: boolean = false;

  @Input()
  source: string;
  @Input()
  claims: ClaimKey[] = [];
  calendarevents: CalendarEvent[] = [];

  @Input()
  filterEnabled: boolean = false;

  @Input()
  showClaimNoLink: boolean = false;

  translationRequest = new TranslationRequest({
		language: sessionStorage.getItem('languagepreference'),
		key: null,
		contNum: 0,
		tableName: null,
		primaryKey: null,
		primaryValue: null,
		lob: null,
		group: 'Shared',
		subGroup: 'Shared',
	  });

  noDataIcon: string = 'search';
  noDataMsg = 'There are no off work.';
  currentYear = new Date().getFullYear();
  currentMonth = new Date().getMonth() + 1;
  currentDate = new Date();
  error: any = null;

  constructor(
    public claimService: ClaimService,
    public dialog: MatDialog,
    private cdr: ChangeDetectorRef,
    private titleCasePipe: TitleCasePipe,
    private translationPipe : TranslationPipe,
    private translationService: TranslationService,
    private session: Session
  ) {}

  async dateUpdated(d: any) {
    if (d?.start === undefined || d?.end === undefined || this.loading) {
      return;
    }
    const viewStartYear = new Date(d.start).getFullYear();
    const viewEndYear = new Date(d.end).getFullYear();
    const viewStartMonth = new Date(d.start).getMonth() + 1;
    const viewEndMonth = new Date(d.end).getMonth() + 1;

    // check if the view spans two different years
    const spansTwoYears = viewStartYear !== viewEndYear;

    // determine if an API call is needed
    const needsApiCall =
      !this.loading &&
      (viewStartYear !== this.currentYear || viewEndYear !== viewStartYear);

    if (needsApiCall) {
      this.cdr.detach();
      this.loading = true;

      let apiYear = viewStartYear;
      let apiMonth = viewStartMonth;

      if (spansTwoYears) {
        if (viewStartMonth === 12) {
          // if december, get next year data
          apiYear = viewStartYear;
          apiMonth = viewStartMonth;
        } else if (viewStartMonth === 1) {
          // if january get last year data
          apiYear = viewEndYear;
          apiMonth = viewEndMonth;
        }
      }

      this.cdr.detach();
      this.loading = true;
      await this.getCalendarData(apiYear.toString(), apiMonth.toString());
      this.currentYear = viewStartYear;
      this.currentMonth = viewStartMonth;
      this.loading = false;
      this.cdr.reattach();
      this.cdr.detectChanges();
    }
  }

  async getCalendarData(currentYear: string, currentMonth: string) {
    //this.loading = true;

    // Ensure translations are loaded before creating calendar events
    if (this.translationRequest && this.translationService.isLanguagePreferenceSet()) {
      await this.translationService.getTranslation(this.translationRequest);
    }

    const owEntries = await this.claimService.getOffWorkCalendarEntries(
      this.claims,
      currentYear,
      currentMonth,
      this.claims[0].hrMasterUid,
      this.claims[0].empUnum
    );

    if (owEntries.length > 0) {
      this.calendarevents = this.getEntries(owEntries);

      this.EventCount = this.calendarevents.length;
      this.events = [];
      this.events = JSON.parse(JSON.stringify(this.calendarevents));
      this.calendarevents.sort(function (a, b) {
        return a.start > b.start ? 1 : -1;
      });

      this.calendarevents.forEach((val) => {
        if (val.end != undefined && val.end != null) {
          val.end = this.removeExtraDay(val.end);
        }
      });
      this.offWorkCalendarEntries = owEntries;
    } else {
      this.events = [];
      this.calendarevents = [];
      this.offWorkCalendarEntries = [];

      setTimeout(() => {
        this.EventCount = 0;
      }, 1000);
    }
    if (this.appCalendar) {
      //debugger;
      this.appCalendar?.render();
    }
    //this.loading = false;
    //this.cdr.reattach();

    //this.cdr.detectChanges();
  }

  async ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.currentMonth = new Date().getMonth() + 1;
    try {
      await this.getCalendarData(
        this.currentYear.toString(),
        this.currentMonth.toString()
      );
    } catch (error) {
      this.error = error;
    }

    this.loading = false;
  }

  private getEntries(owEntries: StatusEvent[]): CalendarEvent[] {
    // reduce indiv daily records into a single records
    // grouped by status if possible
    const ce: CalendarEvent[] = [];

    owEntries
      // sort records by status and date (prep for aggregation step next)
      .sort((a, b) =>
        a.status.localeCompare(b.status) || a.beginDate > b.beginDate ? 1 : -1
      )
      .forEach((e) => {
        ce.push(this.createCalendarEvent(e));
      });

      
    return ce;
  }

  // need to increment the last day to get continuity
  // right on the calendar
  private addDay(date: Date): Date {
    const d = new Date(date);
    d.setDate(d.getDate() + 1);
    return d;
  }

  private removeExtraDay(date: Date): Date {
    const d = new Date(date);
    d.setDate(d.getDate() - 1);
    return d;
  }

  private createCalendarEvent(entry: StatusEvent) {
    let claimDetails: ClaimKey;

    this.claims.forEach((val) => {
      if (val.claimNumber === entry.claimNumber) {
        claimDetails = val;
        if (claimDetails.lob == 'LA' || claimDetails.lob == 'la') {
          claimDetails.lob = 'LV';
        }
      }
    });

    if (entry.isEvent) {
      const eventTitleTranslated = this.translationService.getTranslationForKey(
        'Event',
        this.translationRequest
      );

      const eventBackgroundColor = this.setBackgroundColor('Event');
      return <CalendarEvent>{
        start: entry.beginDate,
        end: this.addDay(entry.endDate),
        title: this.titleCasePipe.transform(eventTitleTranslated),
        allDay: true,
        backgroundColor: eventBackgroundColor,
        borderColor: eventBackgroundColor,
        textColor: '#000000',
        data: { claimDetails, status: entry.status, entry },
      };
    }


    // Get translations directly from service (translations should be loaded before this is called)
    const claimDescriptionKey = entry.claimDescription.toLowerCase();
    const claimDescriptionTranslated = this.translationService.getTranslationForKey(
      claimDescriptionKey,
      this.translationRequest
    );

    const statusKey = this.subStatusForTitle(entry);
    const statusTranslated = this.translationService.getTranslationForKey(
      statusKey,
      this.translationRequest
    );

    return <CalendarEvent>{
      start: entry.beginDate,
      end: this.addDay(entry.endDate),
      title:
        `${this.titleCasePipe.transform(claimDescriptionTranslated)}` + ` - ${this.titleCasePipe.transform(statusTranslated)}`,

      allDay: true,
      backgroundColor:
        entry.statusCode == undefined || entry.statusCode == ''
          ? this.setBackgroundColor(
              entry.status + '-' + entry.subStatus + '-' + entry.absenceStatus
            )
          : this.setBackgroundColorByStatusCode(entry.statusCode),
      data: { claimDetails, status: entry.status, entry },
    };
  }

  private subStatusForTitle(entry: StatusEvent) {
    let status = '';
    if (
      entry.statusCode != undefined &&
      entry.statusCode != null &&
      entry.statusCode.length > 1
    ) {
      if (entry.statusCode.toLowerCase() == 'op') {
        status = 'Pending';
      } else if (entry.statusCode.toLowerCase() == 'oa') {
        status = 'Approved';
      } else if (
        entry.statusCode.toLowerCase() == 'wp' ||
        entry.statusCode.toLowerCase() == 'wa'
      ) {
        status = 'Waiting';
      } else if (
        entry.statusCode.toLowerCase() == 'dp' ||
        entry.statusCode.toLowerCase() == 'da' ||
        entry.statusCode.toLowerCase() == 'od' ||
        entry.statusCode.toLowerCase() == 'cd'
      ) {
        status = 'Denied';
      }
    } else {
      let eleStatus: string = 'Approved';
      if (
        entry.absenceStatus != undefined &&
        entry.absenceStatus != null &&
        entry.absenceStatus.length > 1
      ) {
        status =
          entry.absenceStatus + '-' + entry.status + '-' + entry.subStatus;
      } else {
        status = entry.status + '-' + entry.subStatus;
      }

      if (status.toLocaleLowerCase().indexOf('denied') > -1) {
        eleStatus = 'Denied';
      } else if (status.toLocaleLowerCase().indexOf('waiting') > -1) {
        eleStatus = 'Waiting';
      } else if (status.toLocaleLowerCase().indexOf('pending') > -1) {
        eleStatus = 'Pending';
      } else if (status.toLocaleLowerCase().indexOf('approved') > -1) {
        eleStatus = 'Approved';
      } else if (status.toLocaleLowerCase().indexOf('event') > -1) {
        eleStatus = 'Event';
      }
      status = eleStatus;
    }
    return status;
  }
  private setBackgroundColorByStatusCode(statusCode: string): string {
    let status = '';
    if (statusCode.toLowerCase() == 'op') {
      status = 'Open - Pending';
    } else if (statusCode.toLowerCase() == 'oa') {
      status = 'Open - Approved';
    } else if (
      statusCode.toLowerCase() == 'wp' ||
      statusCode.toLowerCase() == 'wa'
    ) {
      status = 'Waiting';
    } else if (
      statusCode.toLowerCase() == 'dp' ||
      statusCode.toLowerCase() == 'da' ||
      statusCode.toLowerCase() == 'od' ||
      statusCode.toLowerCase() == 'cd'
    ) {
      status = 'Denied';
    }

    return this.setBackgroundColor(status);
  }

  private setBackgroundColor(status: string) {
    let eleStatus: string = 'Approved';
    if (status.toLocaleLowerCase().indexOf('denied') > -1) {
      eleStatus = 'Denied';
    } else if (status.toLocaleLowerCase().indexOf('waiting') > -1) {
      eleStatus = 'Waiting';
    } else if (status.toLocaleLowerCase().indexOf('pending') > -1) {
      eleStatus = 'Pending';
    } else if (status.toLocaleLowerCase().indexOf('approved') > -1) {
      eleStatus = 'Approved';
    } else if (status.toLocaleLowerCase().indexOf('event') > -1) {
      eleStatus = 'Event';
    }

    return {
      Approved: '#0a857d',
      Denied: '#d22828',
      Waiting: '#4d4e57',
      Pending: '#376ec8',
      Event: '#7ceed1',
    }[eleStatus];
  }

  export() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = {
      title: 'Export claims calendar',
    };

    this.dialog.open(this.dialogOffWorkExport, dialogConfig);
  }
}
